









































































import Vue from 'vue';
import { requiredIf } from 'vuelidate/lib/validators';
import { EInputIdentifier } from '@/common/enums/input-identifier.enum';
import TextInput from '../inputs/TextInput.vue';
import SelectInput from '../inputs/SelectInput.vue';
import CountrySelectInput from '../inputs/CountrySelectInput.vue';
import CustomButton from '../../layout/buttons/CustomButton.vue';
import { IContact } from '../../../common/interfaces/contact.interface';

// https://vuelidate.js.org/#sub-accessing-component
function isAreaCodeNeededAndValid(value: string) {
  // I don't know how 'this' works here since it's outside of the component scope, therefore I won't touch it.
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if((!this.contactData.phoneAreaCode || !this.contactData.phoneNumber || !this.contactData.type) && value === ``) {
    return true;
  }
  return String(value).match(/[1-9]/) !== null;
}

interface IContactsFormComponent {
  EInputIdentifier: typeof EInputIdentifier;
  contactData: IContact;
  showEditor: boolean;
}

export default Vue.extend({
  components: {
    CountrySelectInput,
    CustomButton,
    SelectInput,
    TextInput,
  },
  data(): IContactsFormComponent {
    return {
      EInputIdentifier,
      contactData: { ...this.value },
      showEditor: false,
    };
  },
  props: {
    allowEmpty: {
      default: false,
      type: Boolean,
    },
    buttonControl: {
      default: () => {},
      type: Object as () => { [index: string]: unknown },
    },
    instantUpdate: {
      default: false,
      type: Boolean,
    },
    partnerView: {
      default: false,
      type: Boolean,
    },
    showEmptyContactOptions: {
      default: false,
      type: Boolean,
    },
    value: {
      required: true,
      type: Object as () => IContact,
    },
  },
  methods: {
    abort() {
      this.$emit(`abort`);
    },
    addContact() {
      this.$emit(`change`, { ...this.contactData });
      this.$emit(`validate`, !this.$v.$anyError);
    },
    onInput() {
      if(this.instantUpdate) {
        this.$emit(`change`, { ...this.contactData });
        this.$emit(`validate`, !this.$v.$anyError);
      }
    },
    resetValidations() {
      this.$v.$reset();
    },
    validate() {
      this.$v.$touch();
      this.$emit(`validate`, !this.$v.$anyError);
    },
  },
  // I don't know how 'this' works here since it's outside of the component scope, therefore I won't touch it.
  /* eslint-disable @typescript-eslint/ban-ts-comment */
  validations: {
    contactData: {
      countryISO: {
        required: requiredIf(function countryISORequired() {
          // @ts-ignore
          return this.allowEmpty ? (!!this.contactData.phoneAreaCode || !!this.contactData.phoneNumber || !!this.contactData.type) : true;
        }),
      },
      phoneAreaCode: {
        isAreaCodeNeededAndValid,
        required: requiredIf(function phoneAreaCodeRequired() {
          // @ts-ignore
          return this.allowEmpty ? (!!this.contactData.type || !!this.contactData.phoneNumber || !!this.contactData.countryISO) : true;
        }),
      },
      phoneNumber: {
        required: requiredIf(function phoneNumberRequired() {
          // @ts-ignore
          return this.allowEmpty ? (!!this.contactData.phoneAreaCode || !!this.contactData.type || !!this.contactData.countryISO) : true;
        }),
      },
      type: {
        required: requiredIf(function typeRequired() {
          // @ts-ignore
          return this.allowEmpty ? (!!this.contactData.phoneAreaCode || !!this.contactData.phoneNumber || !!this.contactData.countryISO) : true;
        }),
      },
    },
  },
  /* eslint-enable @typescript-eslint/ban-ts-comment */
  watch: {
    value: {
      deep: true,
      handler(value): void {
        this.contactData = { ...value };
      },
      immediate: true,
    },
  },
});
